import { chain, includes } from 'lodash';

export const getButtonsModalByCode = (code, variantsButtons) => {
  return chain(variantsButtons)
    // eslint-disable-next-line array-callback-return
    .find(variant => {
      const { codes } = variant;

      if (codes === code || includes(codes, code)) {
        return variant
      }
    })
    .get('value')
    .value();
}